import React from "react";

const LedgerFilterTabs = ({
  tabs,
  active,
  onChange,
  labelMap = {},
  variant = "main",
}) => {
  const activeClass =
    variant === "dark"
      ? "bg-ink text-white border-ink"
      : "bg-main text-white border-main";

  return (
    <>
      {/* Mobile — scrollable pills */}
      <div className="max850:flex hidden gap-2 overflow-x-auto pb-1 -mx-0.5 scrollbar-none">
        {tabs.map((tb) => {
          const isActive = active === tb;
          return (
            <button
              key={tb}
              type="button"
              onClick={() => onChange(tb)}
              className={`shrink-0 scroll-snap-align-start px-4 py-2 rounded-full text-sm font-semibold border-2 transition-colors whitespace-nowrap font-quicksand ${
                isActive
                  ? activeClass
                  : "bg-card text-inkSecondary border-line hover:border-line"
              }`}
            >
              {labelMap[tb] || tb}
            </button>
          );
        })}
      </div>

      {/* Desktop — segmented bar */}
      <div
        className={`max850:hidden flex w-full mt-3 rounded-xl overflow-hidden bg-subtle border-2 ${
          variant === "dark" ? "border-ink" : "border-main"
        }`}
      >
        {tabs.map((tb) => (
          <button
            key={tb}
            type="button"
            onClick={() => onChange(tb)}
            className={`text-center py-3 font-bold transition-all duration-300 cursor-pointer w-full font-quicksand ${
              active === tb
                ? variant === "dark"
                  ? "bg-ink text-white"
                  : "bg-main text-white"
                : "text-ink hover:bg-card/40"
            }`}
          >
            {labelMap[tb] || tb}
          </button>
        ))}
      </div>
    </>
  );
};

export default LedgerFilterTabs;
